import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageAttachment: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageAttachment"><Path d="M7 4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9V4H2V9C2 11.2091 3.79086 13 6 13C8.20914 13 10 11.2091 10 9V4.5C10 3.11929 8.88071 2 7.5 2C6.11929 2 5 3.11929 5 4.5V9H7V4.5Z" fill="currentColor"/><Path d="M4 22V14.6586C4.62556 14.8797 5.29873 15 6 15C9.31371 15 12 12.3137 12 9V4.5C12 3.57493 11.7209 2.71505 11.2422 2H20V22H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageAttachment;
